"use strict";
exports.clamp = clamp;
var _index = require("./max.js");
var _index2 = require("./min.js");
function clamp(date, interval) {
  return (0, _index2.min)([
    (0, _index.max)([date, interval.start]),
    interval.end
  ]);
}
